<template>
  <v-navigation-drawer color="black" v-model="drawer" app width="250">
    <v-list>
      </v-list>

    <v-divider></v-divider>

    <v-list>
      <v-list-item to="/app/dashboard" prepend-icon="mdi-home">
        <v-list-item-title>Home</v-list-item-title>
      </v-list-item>
      
      <v-list-item v-if="hasPermission('anuncios')"
        to="/app/anuncios"
        prepend-icon="mdi-bulletin-board"
        :disabled="!hasPermission('anuncios')"
        :class="{ 'disabled-item': !hasPermission('anuncios') }"
      >
        <v-list-item-title>Anúncios</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="hasPermission('clientes')"
        to="/app/clientes"
        prepend-icon="mdi-account-group"
        :disabled="!hasPermission('clientes')"
        :class="{ 'disabled-item': !hasPermission('clientes') }"
      >
        <v-list-item-title>Clientes</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="hasPermission('assinaturas')"
        to="/app/assinaturas"
        prepend-icon="mdi-card-bulleted-settings-outline"
        :disabled="!hasPermission('assinaturas')"
        :class="{ 'disabled-item': !hasPermission('assinaturas') }"
      >
        <v-list-item-title>Assinaturas</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="hasPermission('cupons')"
        to="/app/cupons"
        prepend-icon="mdi-tag-multiple-outline"
        :disabled="!hasPermission('cupons')"
        :class="{ 'disabled-item': !hasPermission('cupons') }"
      >
        <v-list-item-title>Cupons</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="hasPermission('categorias')"
        to="/app/categorias"
        prepend-icon="mdi-shape-outline"
        :disabled="!hasPermission('categorias')"
        :class="{ 'disabled-item': !hasPermission('categorias') }"
      >
        <v-list-item-title>Categorias</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="hasPermission('usuarios')"
        to="/app/usuarios"
        prepend-icon="mdi-account"
        :disabled="!hasPermission('usuarios')"
        :class="{ 'disabled-item': !hasPermission('usuarios') }"
      >
        <v-list-item-title>Usuários</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="hasPermission('empresa')"
        to="/app/empresa"
        prepend-icon="mdi-domain"
        :disabled="!hasPermission('empresa')"
        :class="{ 'disabled-item': !hasPermission('empresa') }"
      >
        <v-list-item-title>Empresa</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    const drawer = ref(false);

    // Certifique-se de que a permissão 'assinaturas' está disponível no getter
    const userPermissions = computed(() => store.getters.getPermissions);

    const hasPermission = (permissionIdentifier) => {
      return Array.isArray(userPermissions.value) && userPermissions.value.includes(permissionIdentifier);
    };

    const toggleDrawer = () => {
      drawer.value = !drawer.value;
    };

    return { drawer, toggleDrawer, hasPermission };
  },
};
</script>

<style>
/* Estilos existentes */
.disabled-item {
  opacity: 0.6;
  pointer-events: none;
  cursor: not-allowed;
}

.disabled-item .v-list-item-title,
.disabled-item .v-icon {
  color: #666 !important;
}

.submenu-recuo .v-list-item {
  padding-left: 35px !important;
}
</style>